export const strings = {
  discover: 'Keşfet',
  discover_desc:
    'Global merkezimizdenki Medikal ve Farma etkinlikleirni keşfedin',
  discover_event: 'Etkinlikleri Keşfet',
  mutual_connections: '{number} karşılıklı bağlantı',
  all_invitations: 'Tüm Davetiyeler',
  see_all: 'Tümünü Gör',
  upcoming_events: 'Yaklaşan Etkinlikler',
  past_events: 'Geçmiş Etkinlikler',
  free: 'Bedava',
  paid: 'Ödenen',
  events: 'Etkinlikler',
  edit_event: 'Etkinliği Düzenle',
  recommendations: 'Önerilen Etkinlikler',
  interested: 'Ilgi',
  recommended: 'Önerilen',
  search_events: 'Etkinikleri ara',
  all_events: 'Tüm Etkinlikler',
  viewed: 'Görüntülendi',
  free_event: 'Ücretsiz Etkinlik',
  paid_event: 'Ücretli Etkinlik',
  load_more: 'Daha fazla yükle',
  undisclose: 'Gizli tut',
  week_to_go: 'Hafta kaldı',
  days_to_go: 'Günler kaldı',
  registered: 'Kaydedildi',
  registrations: 'Kayıtlar',
  registration: 'Kayıt',
  deregister: 'Kaydı sil',
  preregister: 'Kaydolmak',
  event_details: 'Etkinlik Detayları',
  show_more: 'Daha Fazlasını Göster',
  show_less: 'Daha Az Göster',
  no_event: 'Hiçbir Etkinlik Mevcut Değil',
  no_recommended_event: 'Önerilen Etkinlik Yok',
  type_0: 'Özel Etkinlik',
  type_1: 'Halka Açık Etkinlik',
  ongoing: 'Devam eden',
  new_event: 'Yeni Etkinlik',
  cover_image: 'Kapak Resmi',
  event_title: 'Etkinlik Başlığı',
  country: 'Ülke',
  event_type: 'Etkinlik Türü',
  location: 'Etkinlik Yeri',
  address: 'Adres Girin',
  start_time: 'Başlangıç Saati',
  end_time: 'Bitiş Zamanı',
  source: 'Kaynak',
  optional: 'Opsiyonel',
  source_placeholder: 'URL bağlantısını buraya yapıştırın',
  description: 'Etkinlik Hakkında',
  desc_placeholder: 'Buraya yazın...',
  payment_method: 'Ödeme şekli',
  time_placeholder: 'Tarih ve saati seçin',
  online: 'Çevrimiçi',
  at_venue: 'Fuar Alanında',
  update: 'Güncelleme',
  create: 'Etkinlik Oluştur',
  server_error: 'Bir şeyler ters gitti!!',
  microsite_events: 'Mikrosite Etkinlikleri',
  errors: {
    cover_required: 'Etkinlik Kapak Görseli gereklidir',
    title_required: 'Etkinlik Başlığı gereklidir',
    title_min_length: 'Etkinlik başlığı en az 3 karakter olmalıdır',
    title_max_length: 'Etkinlik başlığı 250 karakterden uzun olamaz',
    source_url: 'Kaynak geçerli bir URL olmalıdır',
    source_max_limit: 'Kaynak 300 karakterden uzun olamaz',
    start_at_today: 'Bugünün veya önceki tarihi seçemezsiniz',
    start_at_smaller_end: 'Başlangıç tarihi bitiş tarihinden büyük olmamalıdır',
    start_at_required: 'Başlangıç Tarihini girmelisiniz',
    end_at_required: "Bitiş Tarihi'ni girmelisiniz",
    description_required: 'Etkinlik açıklaması gereklidir',
    description_min_length: 'Etkinlik açıklaması en az 3 karakter olmalıdır',
    description_max_length: 'Etkinlik açıklaması 2500 karakterden uzun olamaz',
    speciality_id_required: 'Lütfen bir uzmanlık alanı seçin',
    location_required: 'Etkinlik yeri gereklidir',
    sourceUrlOfVirtualEvent: 'Sanal Etkinlikler için kaynak url gereklidir.',
    registration_ends_on_required: 'Kayıt Bitiş Tarihi girmelisiniz',
    registration_ends_on_date_limit:
      'Kayıt Bitiş Tarihi Bitiş tarihinden daha küçük olmalıdır',
    registration_ends_on_date_min_limit:
      'Kayıt Bitişinin Bitiş Tarihi Geçerli Saatten Daha Az Olamaz',
  },
  delete_event: 'Etkinliği Sil',
  create_event: 'Bir Etkinlik Oluştur',
  cancel: 'İptal etmek',
  pay_at_venue: 'Mekanda Ödeme',
  pay_online: 'Online Öde',
  join: 'Katılmak',
  registration_ends_on: 'Kayıtların sona erme tarihi',
  virtual_event: 'Sanal Etkinlik',
  view_more_details: 'Daha fazla ayrıntı görüntüleyin',
  event_label: 'Olay',
};
